export default "__VITE_ASSET__B69g_Kw2__"